import { Controller } from "@hotwired/stimulus"

// Abonnement Turbo Streams des notifications : l'élément vit sous <html>, hors du <body> que Turbo
// remplace ou morphe à chaque visite (cf. utils/deferred_cells.ts).
const STREAM_CHANNEL = "Turbo::StreamsChannel"

export default class extends Controller {
  static values = {
    signedStreamName: String
  }

  initialize() {
    this.onTurboLoad = () => this.ensureSourceOnHtml()
  }

  connect() {
    this.ensureSourceOnHtml()
    document.addEventListener("turbo:load", this.onTurboLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onTurboLoad)
  }

  ensureSourceOnHtml() {
    const name = this.signedStreamNameValue
    if (!name) return

    const selector = `turbo-cable-stream-source[channel="${STREAM_CHANNEL}"][signed-stream-name="${CSS.escape(name)}"]`
    let source = document.documentElement.querySelector(selector)

    if (!source) {
      source = this.element.querySelector("turbo-cable-stream-source")
    }

    if (!source?.isConnected) return
    if (source.parentElement === document.documentElement) return

    document.documentElement.appendChild(source)
  }
}
